var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInquiryEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 2.18298C4.375 0.72766 6.5 0 9 0C11.5 0 13.75 0.72766 15.5 2.18298C17.25 3.61277 18 5.33617 18 7.35319V15.5489C18 16.2128 17.7031 16.7872 17.1094 17.2723C16.5156 17.7574 15.8125 18 15 18H9C8.11719 18 8.11719 16.5 9 16.3532H15.9844L16 14.5H13.9219L12 14V11H15.5V7C15.5 5.41702 15.2969 4.59787 13.9219 3.5C12.5781 2.3766 10.9375 2 9 2C7.0625 2 5.875 2.3766 4.5 3.5C3.15625 4.59787 2.5 5.91702 2.5 7.5V11L6 11.0156V14L4.5 14.5H3C2.1875 14.5 1.59375 13.9851 1 13.5C0.40625 13.0149 0 11.6795 0 11.0156V7.35319C0 5.33617 0.875 3.61277 2.625 2.18298Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInquiryEmail);
export default __webpack_public_path__ + "static/media/icon-Inquiry-email.62958d082f309a4567d333eed29d8692.svg";
export { ForwardRef as ReactComponent };